export enum Skadekategori {
    Kjoretoy = 'kjoretoy',
    Bat = 'bat',
    HusOgHytte = 'husoghytte',
    Innbo = 'innbo',
    Reise = 'reise',
    DegOgDineUlykkesskadeEllerAnnet = 'degogdineulykkesskadeellerannet',
    DegOgDineUforhetDodsfallEllerKritiskSykdom = 'degogdineuforhetdodsfallellerkritisksykdom',
    Naring = 'naring',
    NaringNaringsbyggOgEiendeler = 'naringnaringsbyggogeiendeler',
    Landbruk = 'landbruk',
    LandbrukProduksjonsdyr = 'landbrukproduksjonsdyr',
    IngenSkadekategoriValgt = 'INGEN_SKADEKATEGORI_VALGT',
    Dyr = 'dyr',
    Rettshjelp = 'rettshjelp',
    Ansvar = 'ansvar',
}

export const skadekategoriFrom = (skadekategori: string): Skadekategori => {
    switch (skadekategori.toLowerCase()) {
        case Skadekategori.Kjoretoy.valueOf():
            return Skadekategori.Kjoretoy;
        case Skadekategori.Bat.valueOf():
            return Skadekategori.Bat;
        case Skadekategori.HusOgHytte.valueOf():
            return Skadekategori.HusOgHytte;
        case Skadekategori.Innbo.valueOf():
            return Skadekategori.Innbo;
        case Skadekategori.Reise.valueOf():
            return Skadekategori.Reise;
        case Skadekategori.DegOgDineUlykkesskadeEllerAnnet.valueOf():
            return Skadekategori.DegOgDineUlykkesskadeEllerAnnet;
        case Skadekategori.DegOgDineUforhetDodsfallEllerKritiskSykdom.valueOf():
            return Skadekategori.DegOgDineUforhetDodsfallEllerKritiskSykdom;
        case Skadekategori.Naring.valueOf():
            return Skadekategori.Naring;
        case Skadekategori.Landbruk.valueOf():
            return Skadekategori.Landbruk;
        case Skadekategori.LandbrukProduksjonsdyr.valueOf():
            return Skadekategori.LandbrukProduksjonsdyr;
        case Skadekategori.Dyr.valueOf():
            return Skadekategori.Dyr;
        case Skadekategori.Rettshjelp.valueOf():
            return Skadekategori.Rettshjelp;
        case Skadekategori.Ansvar.valueOf():
            return Skadekategori.Ansvar;
        case Skadekategori.NaringNaringsbyggOgEiendeler.valueOf():
            return Skadekategori.NaringNaringsbyggOgEiendeler;
        default:
            return Skadekategori.IngenSkadekategoriValgt;
    }
};

export const skadekategoriToUrlPathName = (skadekategori: Skadekategori | undefined): string =>
    skadekategori ? skadekategori.valueOf() : Skadekategori.IngenSkadekategoriValgt.valueOf();
